// auth

const state = {
	authenticated: localStorage.getItem('authenticated') || null,
	me: {},
	ability: {},
};

export default state;